import { Modal } from "antd";
import moment from "antd/node_modules/moment";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FundsStore } from "./FundsStore";
import { dataURItoBlob, fmtMoney } from "../../common/Utils";
import FileSaver from "file-saver";

export class FundStore {
  id: string = "";
  fundsStore: FundsStore;
  fund?: any;
  saving = false;
  saving2 = false;
  showGoalsAchievedDlg = false;

  exporting = false;

  types = [
    { id: "", name: "All" },
    { id: "family", name: "Family" },
    { id: "invite", name: "Invite Family & Friends" },
  ];

  filter = {
    name: "",
    type: "",
  };

  query = {
    name: "",
    type: "",
  };

  @action onSearch() {
    this.filter.name = this.query.name;
    this.filter.type = this.query.type;
  }

  constructor(fundsStore: FundsStore) {
    makeAutoObservable(this, {
      fundsStore: false,
    });
    this.fundsStore = fundsStore;
  }

  get canPerGoalSave() {
    if (this.fund?.type !== 2 || this.fund.complete) return false;

    return this.fund.perGoalDonates.filter((x) => x.count !== x.achieved).length > 0;
  }

  get canPerGoalComplete() {
    if (this.fund?.type !== 2 || this.fund.complete) return false;
    return moment().isAfter(this.fund.end);
  }

  get donates() {
    if (!this.fund) {
      return [];
    } else {
      return this.fund.donates
        .filter((x) => {
          if (this.filter.name) {
            let name = x.inviteName || x.user?.name;
            if (name) {
              return name.toLowerCase().includes(this.filter.name.toLowerCase());
            } else {
              return false;
            }
          } else {
            return true;
          }
        })
        .filter((x) => {
          if (this.filter.type) {
            if (this.filter.type === "invite") {
              return !!x.inviteName;
            } else {
              return !x.inviteName;
            }
          } else {
            return true;
          }
        });
    }
  }

  get totalAmount() {
    if (!this.fund) {
      return fmtMoney(0);
    } else {
      if (this.fund?.type === 2 && !this.fund?.complete) {
        return "";
      }
      const total = this.donates.reduce((t, c) => t + c.amount, 0);
      return fmtMoney(total / 100.0);
    }
  }

  get isPerGoal() {
    return this.fund?.type === 2;
  }

  @action savePerGoalAchieved() {
    if (!this.canPerGoalSave) return;

    const items = this.fund.perGoalDonates
      .filter((x) => x.count !== x.achieved)
      .map((it) => {
        return {
          id: it.id,
          count: it.achieved,
        };
      });
    this.saving = true;
    return Api.fr
      .saveFundPerGoalResult(this.id, items)
      .then(() => {
        this.showGoalsAchievedDlg = false;
        this.refresh();
      })
      .finally(() => (this.saving = false));
  }

  @action completePerGoal() {
    if (this.fund.complete) return;

    Modal.confirm({
      content: "Are you sure to set this Fundraiser Complete?",
      onOk: () => {
        this.saving2 = true;
        return Api.fr
          .completeFundPerGoalByEmployee(this.id)
          .then(() => this.refresh())
          .finally(() => (this.saving2 = false));
      },
    });
  }

  @action setPerGoalAchieved(id, val) {
    console.log("setPerGoalAchieved", id, val);
    const item = this.fund.perGoalDonates.find((x) => x.id === id);
    if (item) {
      item.achieved = val;
      this.fund.perGoalDonates = [...this.fund.perGoalDonates];
    }
  }

  @action refresh() {
    Api.fr.fundraising(this.id).then((res) => {
      runInAction(() => {
        const fund = res.data.fundraiser;
        console.log("fund", this.fund);
        if (fund.type === 2) {
          fund.perGoalDonates.forEach((it) => {
            it.count = it.count || 0;
            it.achieved = it.count;
          });
        }
        this.fund = fund;
      });
    });
  }
  @action
  active(id: string) {
    if (this.id === id) return;
    this.id = id;
    this.filter.name = "";
    this.filter.type = "";
    this.query.name = "";
    this.query.type = "";
    console.log("active fund id", id);
    this.refresh();
  }

  @action onExport() {
    this.exporting = true;
    Api.fr
      .exportDonates(this.id)
      .then((res) => {
        runInAction(() => {
          const { filename, data } = res.data.exportDonates;
          let blob = dataURItoBlob(data, filename);
          FileSaver.saveAs(blob, filename);
        });
      })
      .finally(() => (this.exporting = false));
  }
}
